/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const PutDivisionParentAssignmentDataParser = 
/* #__PURE__ */ parsers.object([
    ['parentId', /* #__PURE__ */ parsers.maybeNull(codecNumber), 'parent_id'],
]);
export class PutDivisionParentAssignmentData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PutDivisionParentAssignmentDataParser.decode(input).map(res => new PutDivisionParentAssignmentData(res));
    }
    static unsafeDecode(input) {
        return PutDivisionParentAssignmentData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PutDivisionParentAssignmentDataParser.encode(data);
    }
    static schema() {
        return PutDivisionParentAssignmentDataParser.schema();
    }
}
